module.exports = __webpack_public_path__ + "bf9f5d50c1b928ff21436517a1a95ad9.otf";